import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <>
      <div className="min-h-screen bg-background">
        <Outlet />
      </div>
      {import.meta.env.DEBUG_FRONTEND_ROUTER === 'true' && (
        <TanStackRouterDevtools position="bottom-right" />
      )}
    </>
  )
}
